import i18n from 'i18next'
import { IssueEntity } from 'types/IssueEntity'
import { formatMoney, formatNumber } from '../../packages/utils/numberFormatters'
import { isUnit } from './sharesOrUnits'

export const getSubPriceLabel = ({
    issue,
    locale,
    showUnitToShareConversion = true,
}: {
    issue: Pick<
        IssueEntity,
        'ipoIntervalHigh' | 'ipoIntervalLow' | 'sharesInUnit' | 'type' | 'unitSubPrice' | 'currency'
    >
    locale: string
    showUnitToShareConversion?: boolean
}) => {
    const unitLabel = i18n.t('pages.issues.quantityLabels.unit')
    const shareLabel = i18n.t('pages.issues.quantityLabels.share')
    const label = isUnit(issue) ? unitLabel : shareLabel
    const formatMoneyOptions = {
        locale,
        currencySymbol: issue.currency,
    }

    if (issue.unitSubPrice === null) {
        if (issue.type === 'IPO' && issue.ipoIntervalLow && issue.ipoIntervalHigh) {
            return i18n.t('pages.issues.subPriceLabel.ipoInterval', {
                low: formatNumber(issue.ipoIntervalLow, { decimals: 2, locale }),
                high: formatNumber(issue.ipoIntervalHigh, { decimals: 2, locale }),
                currency: issue.currency,
                label,
                interval: i18n.t('pages.issues.subPriceLabel.interval'),
            })
        }
        return i18n.t('pages.issues.terms.notDeterminedYet')
    } else if (issue.sharesInUnit === null || (issue.sharesInUnit === 1 && !isUnit(issue))) {
        return i18n.t('pages.issues.subPriceLabel.perLabel', {
            price: formatMoney(issue.unitSubPrice, formatMoneyOptions),
            label,
        })
    } else if (issue.sharesInUnit >= 1 && isUnit(issue)) {
        if (showUnitToShareConversion) {
            return i18n.t('pages.issues.subPriceLabel.unitWithShareConversion', {
                unitPrice: formatMoney(issue.unitSubPrice, formatMoneyOptions),
                unit: unitLabel,
                equivalent: i18n.t('pages.issues.subPriceLabel.equivalent'),
                sharePrice: formatMoney(+issue.unitSubPrice / issue.sharesInUnit, formatMoneyOptions),
                share: shareLabel,
            })
        }
        return i18n.t('pages.issues.subPriceLabel.perShare', {
            price: formatMoney(issue.unitSubPrice / issue.sharesInUnit, formatMoneyOptions),
            share: shareLabel,
        })
    } else if (issue.sharesInUnit === 0) {
        return i18n.t('pages.issues.subPriceLabel.perUnit', {
            price: formatMoney(issue.unitSubPrice, formatMoneyOptions),
            unit: unitLabel,
        })
    }
    return ''
}
